import { defineMessages, IntlShape } from 'react-intl'
import * as yup from 'yup'

import { ICreateConstraintsFormValues } from 'features/RoutingProjects/types'
import { isEmpty } from 'lodash'
import { getSchemaAssociations } from 'utils/schema'

const messages = defineMessages({
  required: {
    id: 'routingProjects.constraints.required',
    defaultMessage: 'Required'
  },
  min: {
    id: 'routingProjects.constraints.min',
    defaultMessage: 'Minimum value is {min}'
  },
  originOrDestinationRequired: {
    id: 'routingProjects.constraints.originOrDestinationRequired',
    defaultMessage: 'Origin or Destination is required'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<ICreateConstraintsFormValues> => {
  return yup.object().shape(
    {
      origin: yup
        .object()
        .shape({
          id: yup.string().required(),
          label: yup.string().required()
        })
        .nullable()
        .when('destination', {
          is: (destination: ICreateConstraintsFormValues['destination']) => isEmpty(destination?.id),
          then: yup
            .object()
            .shape({
              id: yup.string().required(),
              label: yup.string().required()
            })
            .nullable()
            .required(intl.formatMessage(messages.originOrDestinationRequired)),
          otherwise: yup
            .object()
            .shape({
              id: yup.string().required(),
              label: yup.string().required()
            })
            .nullable()
            .optional()
        }),
      destination: yup
        .object()
        .shape({
          id: yup.string().required(),
          label: yup.string().required()
        })
        .nullable()
        .when('origin', {
          is: (origin: ICreateConstraintsFormValues['origin']) => isEmpty(origin?.id),
          then: yup
            .object()
            .shape({
              id: yup.string().required(),
              label: yup.string().required()
            })
            .nullable()
            .required(intl.formatMessage(messages.originOrDestinationRequired)),
          otherwise: yup
            .object()
            .shape({
              id: yup.string().required(),
              label: yup.string().required()
            })
            .nullable()
            .optional()
        }),
      vehicles: yup
        .array()
        .of(
          yup.object().shape({
            number: yup
              .number()
              .nullable()
              .min(1, ({ min }) => intl.formatMessage(messages.min, { min }))
              .required(intl.formatMessage(messages.required)),
            capacity: yup
              .number()
              .nullable()
              .min(1, ({ min }) => intl.formatMessage(messages.min, { min }))
              .required(intl.formatMessage(messages.required))
          })
        )
        .min(1)
        .required(),
      maxStops: yup
        .number()
        .nullable()
        .optional()
        .min(1, ({ min }) => intl.formatMessage(messages.min, { min })),
      maxDuration: yup
        .number()
        .nullable()
        .optional()
        .min(1, ({ min }) => intl.formatMessage(messages.min, { min })),
      maxDistance: yup
        .number()
        .nullable()
        .optional()
        .min(1, ({ min }) => intl.formatMessage(messages.min, { min })),
      stopDuration: yup.number().nullable().optional(),
      startTime: yup.string().nullable().optional(),
      endTime: yup.string().nullable().optional()
    },
    getSchemaAssociations(['origin', 'destination'])
  )
}
